import { FC, RefObject, useCallback, useRef, useLayoutEffect, useMemo } from "react";
import classNames from "classnames";
import { PropsWithChildren, useEffect, useState } from "react";
import styles from "./Styles/ChangeableGrid.module.scss";
import defaultStyles from "../../../Business/styles/index.module.scss";
import GridPaginator from "../gridPaginator";
import { ContextMenu } from "../../contextMenu/contextMenu";
import GridUISettings from "../default/gridUiSettings";
import { useAppContext } from "../../../system/providers/appContextProvider";
import { useUserContext } from "../../../system/providers/userContextProvider";
import { DownIcon, UpIcon, SortIcon } from "../../../libs/corporate/icons/outlined/directions/ChevronCollection";
import { DateTime } from "luxon";
import { } from "../../../Services/Extensions/Boolean";
import { } from "../../../Services/Extensions/DateTime";
import { v4 as uuidv4 } from "uuid";
import { DecimalInputV2, NumberInputWithSideEffect, TextInput } from "../../controls/inputs/BaseInput";
import { Tooltip } from "antd";
import { addValueToArray } from "../../../system/functions/addValToArray";
import { getKizCount } from "../../../system/functions/getKizCount";
import { CheckBoxMultiple } from "../../checkboxes/checkBoxMultiple";
import { TableHeader } from "../components/TableHeader";
import { FormattedValueView, getFormattedCellValue } from "../components/FormattedValueView";
import { orderBy } from "lodash";
import { DocumentType, GridRowHeightEnum } from "../../../../src/@types/enumsGlobal"
import { Spinner } from "../../spiner/Spinner";
import FlexRow from "../../controls/FlexRow";
import FlexColumn from "../../controls/FlexColumn";
import { GridFilterAction } from "../../../system/hooks/useGridFilter";
import { CheckBox } from "../../controls/checkbox";
import { Checkbox as AntCheckbox } from 'antd';
import { useTranslation } from "react-i18next";
import * as ActionIcons from "../../../libs/corporate/icons/outlined/editor/ActionCollection"
import { copyToClipboard } from "../../../system/functions/copyToClipboard";
import { getStyleBorderTr, IGridStyleItem, IGridStyleOptions } from "./utils/gridStyles";
import { shouldHighlightCell } from "./utils/cellStyles";
import { IErrorItem } from "../../alert/alertHelpers";
import { IPluginSettingsDTO } from "../../../libs/ui-api-dto/pluginSettings";


//local Interfaces
export interface IGridCellWithWidth extends IChangeableGridCell {
    width: number;
    idGlobal: string;
}

interface IPage {
    pageNumber: number;
    prevPageNumber: number;
}

export interface actionGridRow {
    delete?: () => void;
}

interface IMousePosition {
    x: number;
    y: number;
}
interface IEditRowFiled {
    edit: boolean;
    idField: string | null;
    idGlobal: string | null;
    value: string | number | null;
}

export interface IChangeDataGrid {
    propertyName: string;
    value: string | number | boolean;
    oldValue?: string | number;
    idGlobal: string;
}

interface IColumnToSave {
    columns: IGridColumn[];
    save: boolean;
}
   
interface IMaxDiscountValues {
    [key: string]: number;
  }

interface ISearchRows {
    value: string;
    order: number;
    propertyName: string;
}

interface IDefaultGridProps<TViewDTO> {
    //value
    gridId: string;
    plugin: IPluginSettings;
    data: TViewDTO[];
    filter: IGridFilter;
    totalCount: number;
    actionGridRow?: actionGridRow;
    selectedItem?: IGridRow;
    hiddenPagination?: { hiddenCountRow: boolean | undefined; hiddenNumberPage: boolean | undefined };
    autoSelect?: boolean;
    numbering?: boolean;
    separator?: boolean;
    contextMenuItems?: IContextMenuItem[];
    dataProvider?: any;
    onPageLoad?: (scrollDirection: string, scrollCallback?: (verticalPivot: any, part: any) => void) => void;
    getStyleRow?: (row: IGridRow) => string | null;
    disabledCell?: (cell: IGridCellWithWidth) => boolean | undefined;
    getStyleCell?: (processedCell: IGridCell, cells: IGridCell[]) => string | null;
    isEditKizs?: boolean;
    enableSortByAlerts?: boolean;
    itemsFilter?: IItemFilter[];
    itemsValidation?: IValidationItem[];
    items?: any;
    isShowAll?: boolean;
    hideSettingstButton?: boolean;
    numerator?: number;
    multipleSelect?: boolean;
    selectedItems?: IGridRow[];
    disabledNumberInput?: boolean;
    documentStateProc?: boolean;
    maxDiscountValue?: IMaxDiscountValues;
    isSortDataReverse?: boolean;
    localSortingData?: boolean;
    documentType?: DocumentType;
    sysOptionsKizValidationType?: string;
    selectById?: string;
    autoSelectFirst?: boolean;
    sendRequest?: boolean;
    hideBooleanIfNull?: boolean;
    virtualizedData?: boolean;
    visibleRows?: number;
    classNameBodyTr?: string;
    searching?: boolean;
    isCrosspharmacy?: boolean;
    isDocumentProcess?: boolean;
    mapDisabledField?: Map<string, boolean>;
    banEnterZerro?: boolean;
    autoHighlightOnChange?: boolean; // При true — автоматически выделяет изменённый/добавленный элемент
    customKizControl?: (item: IChangeableGridRow) => boolean;
    // Refs для точечных target-элементов tour.
    tourRefs?: {
        search?: RefObject<HTMLDivElement>
    }

    dispatchFilter?: (action: GridFilterAction) => void;
    onMultipleSelect?: (rows: IGridRow[]) => void; // экш для выделения элементов
    setItemsValidation?: (value: IValidationItem[]) => void;
    onChangeData?: (value: IChangeDataGrid) => void;
    // onEndChangeData?: (value: IChangeDataGrid) => void;

    onBlur?: (value: IChangeDataGrid) => void;
    onClick?: (row: IGridRow | undefined) => void;
    onSelect?: (row: IGridRow | undefined) => void;
    onDoubleClick?: (row: IGridRow) => void;
    onEnter?: (row: IGridRow) => void;
    onColumnEnter?: (column: IChangeDataGrid) => void;
    
    onSort: (column: IGridColumn) => void;
    onFilterDelete: (column: IGridColumn) => void;
    onPageNumberChange: (pageNumber: number) => void;
    onNumberPerPageChange: (numberPerPage: number) => void;
    onGridRowContextMenuMouseClick?: (selectedRow: IGridRow, position: IMousePosition) => JSX.Element;

    onRowValidate?: (row: IChangeableGridRow) => string
    // Точечная визуальная валидация input: при true применяется красный класс errInput.
    isCellInvalid?: (cell: IGridCellWithWidth, row: IChangeableGridRow) => boolean;

    renderCell?: (
        cell: IGridCellWithWidth, 
        row: IGridRow, 
        onDataChange: (value: any) => void,
        additionalData?: any
    ) => React.ReactNode;
    renderCustomCell?: (cell: IGridCellWithWidth, row: IChangeableGridRow) => React.ReactNode;
}
//local Interfaces
//local Function
function compareByOrder(a: IComparer, b: IComparer) {
    if (a.order === undefined || b.order === undefined) return 0;

    if (a.order < b.order) return -1;

    if (a.order > b.order) return 1;

    return 0;
}
//local Function
//Main FC
function sortArrayByField(items: any[], field: string, orderDesc: boolean) {
    return orderBy(items, [field], [orderDesc ? 'desc' : 'asc']);
}
export const ChangeableGrid = <TViewDTO,>(props: PropsWithChildren<IDefaultGridProps<TViewDTO>>) => {
    //cntx
    const appCtx = useAppContext();
    const userCtx = useUserContext();
    let gridRef = useRef<HTMLTableSectionElement>(null);
    //cntx
    //contextMenu
    const [gridRowContextMenuVisible, setGridRowContextMenuVisible] = useState(false);
    const [gridHeaderContextMenuVisible, setGridHeaderContextMenuVisible] = useState(false);
    const [showGridHeaderSettings, setShowGridHeaderSettings] = useState(false);
    const [gridRowContextMenu, setGridRowContextMenu] = useState<JSX.Element | undefined>();
    const [headerCtxPosY, setHeaderCtxPosY] = useState(0);
    const [headerCtxPosX, setHeaderCtxPosX] = useState(0);
    const [typeChecked, setTypeChecked] = useState<string>("emptyField");
    const [allChecked, setAllChecked] = useState<boolean>(false);
    //contextMenu
    //plugins
    const defaultPlugin: IPluginSettings = JSON.parse(JSON.stringify(props.plugin)) as IPluginSettings;
    const [pluginSettings, setPluginSettings] = useState<IPluginSettings>(defaultPlugin);

    const [gridColumnsToSave, setGridColumnsToSave] = useState<IColumnToSave>({ columns: [], save: false });
    //plugins
    //main
    const [data, setData] = useState<any[]>(props?.data?.map((x) => ({ ...x, idRow: uuidv4() })));
    const [showAll, setShowAll] = useState<boolean | undefined>(props.isShowAll);
    const [alertsSortOrder, setAlertsSortOrder] = useState(true); // true - по убыванию
    const [sortByAlertsEnabled, setSortByAlertsEnabled] = useState(false);
    const [rows, setRows] = useState<IChangeableGridRow[]>([]);
    const [searchRows, setSearchRows] = useState<ISearchRows>({value: '', order: 0, propertyName: ''});
    const [searchRowsArray, setSearchRowsArray] = useState<ISearchRows[]>([]);
    const [, setViewState] = useState<GridStateType>("view");
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const selectFirstRowAfterSortRef = useRef<boolean>(false);
    const selectFirstRowAfterSearchRef = useRef<boolean>(false);

    useEffect(() => {
        let newArr: ISearchRows[] = [];
        for (let i = 0; i < searchRowsArray.length; i++) {
            if ((searchRowsArray[i].propertyName !== searchRows.propertyName) && (searchRowsArray[i].value !== '')) {
                newArr.push(searchRowsArray[i]);
            }
        }
        if (searchRows.value !== '') {
            newArr.push(searchRows);
        }
        setSearchRowsArray(([...newArr]));
    }, [searchRows]);

    const [searchDocumentValue, setSearchDocumentValue] = useState<string>('');

    const { t } = useTranslation();
    const baseT = (value: string) => t('grids.' + value);
    
    //main
    //changeValue
    const [editRowField] = useState<IEditRowFiled>({ edit: false, idField: null, idGlobal: null, value: null });

    //changeValue
    //pagination
    const [clientHeight, setClientHeight] = useState<number | null>(getClientHeight(data.length));
    const [pageNumber, setPageNumber] = useState<IPage>({
        pageNumber: props.filter.pageNumber,
        prevPageNumber: props.filter.pageNumber,
    });
    let tableRef = useRef<HTMLDivElement>(null);

    const savedScrollLeft = useRef<number | null>(null);
    const scrollLockCleanup = useRef<(() => void) | null>(null);

    const suppressScrollEvent = useRef<boolean>(false);

    useLayoutEffect(() => {
        if (savedScrollLeft.current !== null && tableRef.current) {
            suppressScrollEvent.current = true;
            tableRef.current.scrollLeft = savedScrollLeft.current;
            suppressScrollEvent.current = false;
            if (!gridColumnsToSave.save) {
                scrollLockCleanup.current?.();
                scrollLockCleanup.current = null;
                savedScrollLeft.current = null;
            }
        }
    }, [pluginSettings.columns, gridColumnsToSave.save]);

    const paginationScrollLeft = useRef<number | null>(null);
    const paginationScrollLockCleanup = useRef<(() => void) | null>(null);

    useLayoutEffect(() => {
        if (paginationScrollLeft.current !== null && tableRef.current) {
            suppressScrollEvent.current = true;
            tableRef.current.scrollLeft = paginationScrollLeft.current;
            suppressScrollEvent.current = false;
            paginationScrollLockCleanup.current?.();
            paginationScrollLockCleanup.current = null;
            paginationScrollLeft.current = null;
        }
    }, [data]);

    const selectionScrollLeft = useRef<number | null>(null);

    useLayoutEffect(() => {
        if (selectionScrollLeft.current !== null && tableRef.current) {
            suppressScrollEvent.current = true;
            if (tableRef.current.scrollLeft !== selectionScrollLeft.current) {
                tableRef.current.scrollLeft = selectionScrollLeft.current;
            }
            suppressScrollEvent.current = false;
        }
    }, [selectedItem]);

    const selectRow = (row: IGridRow | undefined) => {
        selectionScrollLeft.current = tableRef.current?.scrollLeft ?? null;
        setSelectedItem(row);
    };

    const multiSelectScrollLeft = useRef<number | null>(null);

    useLayoutEffect(() => {
        if (multiSelectScrollLeft.current !== null && tableRef.current) {
            suppressScrollEvent.current = true;
            if (tableRef.current.scrollLeft !== multiSelectScrollLeft.current) {
                tableRef.current.scrollLeft = multiSelectScrollLeft.current;
            }
            suppressScrollEvent.current = false;
        }
    }, [props.selectedItems]);

    useLayoutEffect(() => {
        if (!tableRef.current) return;
        const hasSelection = selectionScrollLeft.current !== null;
        const hasMulti = multiSelectScrollLeft.current !== null;
        if (!hasSelection && !hasMulti) return;

        suppressScrollEvent.current = true;

        if (hasSelection) {
            if (tableRef.current.scrollLeft !== selectionScrollLeft.current!) {
                tableRef.current.scrollLeft = selectionScrollLeft.current!;
            }
            selectionScrollLeft.current = null;
        }

        if (hasMulti) {
            if (tableRef.current.scrollLeft !== multiSelectScrollLeft.current!) {
                tableRef.current.scrollLeft = multiSelectScrollLeft.current!;
            }
            multiSelectScrollLeft.current = null;
        }

        suppressScrollEvent.current = false;
    }, [rows]);

    const prevDataLengthRef = useRef<number>(0);

    const yDividerPos = useRef<number>(0);
    let lastScrollPosition = 0;

    const [wheelDown, setWheelDown] = useState<boolean>(false);

    const [sortingStatus, setSortingStatus] = useState<boolean>(true);
    const [lastEditedIdGlobal, setLastEditedIdGlobal] = useState<string | null>(null);
    const prevPropsDataRef = useRef<any[]>([]);

    // get grid height
    function getClientHeight(dataLength: number) {
        if (dataLength >= 10) {
            return 380;
        } else if (dataLength == 1) {
            return 120;
        } else {
            return dataLength * 47 + 44;
        }
    }

    //pagination
    // set clientHeight on the quantity data
    useEffect(() => {
        setClientHeight(getClientHeight(data.length));
    }, [data.length]);

    function addMissingFieldsToViewTable(currentData: any[]): any[] {
        return currentData.map(item => {
            let newItem = Object.assign({}, item);
            pluginSettings.columns.forEach(setting => {
                if (setting.visibility && !newItem.hasOwnProperty(setting.propertyName)) {
                    newItem[setting.propertyName] = null;
                }
            });
            return newItem;
        })
    }

    ///virtualized
    const visibleRows: number = props.visibleRows ?? 15;
    const ROW_HEIGHT = pluginSettings.rowHeight ?? 36;
    const [startInterval, setStartInterval] = useState<number>(0);

    const virtualizedStyles = {
        height: ROW_HEIGHT * visibleRows + 1,
        overflow: 'auto',
    }

    const virtualPadding = useMemo(() => {
        if (!props.virtualizedData) return { paddingTop: 0, paddingBottom: 0 };
        
        const safeStart = Math.max(0, startInterval);
        const topPadding = safeStart * ROW_HEIGHT;
        const remainingRows = Math.max(0, data.length - safeStart - visibleRows - 1);
        const bottomPadding = remainingRows * ROW_HEIGHT;
        
        return {
            paddingTop: topPadding,
            paddingBottom: bottomPadding
        };
    }, [props.virtualizedData, startInterval, visibleRows, data.length, ROW_HEIGHT]);

    function showQuantityPositions(): number {
        if (props.virtualizedData) {
            return props.data.length;
        }
        else return props.onPageLoad ? props.totalCount : data.length
    }

    //get rows when changed data or selectedItem
    useEffect(() => {
        let rows: IChangeableGridRow[] = [];
        addMissingFieldsToViewTable(data).forEach((i, index) => {
            let cells: IChangeableGridCell[] = [];
            Object.entries(i).forEach((prop) => {
                try {
                    const propertyName = prop[0];
                    let value = prop[1];
                    const column = pluginSettings.columns.find((item) => item.propertyName === propertyName);

                    if (value && value !== null && value !== "" && column) {
                        switch (column.propertyType) {
                            case "boolean":
                                value = (value as boolean).toYesNoString();
                                break;
                            case "date":
                                if (typeof value !== "string") {
                                    value = (value as DateTime).toF3DateFormat(userCtx);
                                    break;
                                } else {
                                    value = null;
                                    break;
                                }
                            case "datetime":
                                if (typeof value !== "string") {
                                    value = (value as DateTime).toF3DateTimeFormat(userCtx);
                                    break;
                                } else {
                                    value = null;
                                    break;
                                }
                        }
                    }

                    const order = column?.order as number;
                    //if (propertyName == 'documentState') {
                    //    cells.push({ value: returnStatusIcon(DocumentStateType[prop[1]]), propertyName: 'СД', order: index - 1, visibility: true })
                    //}
                    cells.push({
                        idField: uuidv4(),
                        changeable: column?.changeable ? true : false,
                        value,
                        propertyType: column?.propertyType as string,
                        propertyName,
                        order,
                        visibility: pluginSettings.columns.find((x) => x.propertyName === propertyName)?.visibility as boolean,
                    } as IChangeableGridCell);
                } catch (ex) {
                    console.trace(prop[0] + " -> " + prop[1]);
                    console.trace(ex);
                }
            });
            props?.multipleSelect
            ? rows.push({
                idGoodsGlobal: i["idGoodsGlobal"] as string,
                idGlobal: i["idGlobal"] as string,
                idRow: i["idRow"] as string,
                displayName: i["displayName"] as string,
                cells: cells.filter((item) => item.order !== undefined && item.order !== null).sort(compareByOrder),
                isDeleted: i["deleted"] as boolean,
                isSelected: props?.selectedItems?.find((x) => x.idGlobal === i["idGlobal"]) === undefined ? false : true,
                absentInGC: i["absentInGC"],
                isKiz: i["isKiz"],
                isKizBox: i["isKizBox"],
                countKizScan: i["countKizScan"],
                isOsu: i["isOsu"],
                numerator: i["numerator"],
                denominator: i["denominator"],
                quantity: i["quantity"],
                actualQuantity: i["actualQuantity"],
                quantityFrom: i["quantityFrom"],
                documentalQuantity: i["documentalQuantity"],
                kizWithdrawalComplete: i['kizWithdrawalComplete'] as boolean
              })
            : rows.push({
                idGoodsGlobal: i["idGoodsGlobal"] as string,
                idGlobal: i["idGlobal"] as string,
                idRow: i["idRow"] as string,
                displayName: i["displayName"] || (i["name"] as string),
                cells: cells.filter((item) => item.order !== undefined && item.order !== null).sort(compareByOrder),
                isDeleted: i["deleted"] as boolean,
                isSelected: i["idRow"] === selectedItem?.idRow ? true : false,
                absentInGC: i["absentInGC"],
                isKiz: i["isKiz"],
                isKizBox: i["isKizBox"],
                countKizScan: i["countKizScan"],
                isOsu: i["isOsu"],
                numerator: i["numerator"],
                denominator: i["denominator"],
                quantity: i["quantity"],
                actualQuantity: i["actualQuantity"],
                quantityFrom: i["quantityFrom"],
                documentalQuantity: i["documentalQuantity"],
                kizWithdrawalComplete: i['kizWithdrawalComplete'] as boolean
            });
        });
        setRows(rows);
    }, [data, selectedItem, props.selectedItems, gridColumnsToSave, pluginSettings]);

    useEffect(() => {
        setTimeout(() => {
            const rows = getRows();
            const item = rows?.find(x => x.idGlobal === props.selectById);
            if (item && (props.selectById as string)?.length > 0) {
                const rowIndex = rows.findIndex(x => x.idGlobal === props.selectById);
                setSelectedItem(item);
                setCurrentTrIndex(rowIndex);
                props.onSelect?.(item);
            }                
        }, 300);
    }, [props.selectById]);

    //dynamic separator
    const onMouseHoldDown = (e) => {
        yDividerPos.current = e.clientY;
    };
    const onMouseHoldUp = () => {
        yDividerPos.current = 0;
    };

    const onMouseHoldMove = (e) => {
        if (!yDividerPos.current) {
            return;
        }
        setClientHeight(clientHeight + e.clientY - yDividerPos.current);
        yDividerPos.current = e.clientY;
    };

    useEffect(() => {
        if (allChecked) {
            let multipleArr: IGridRow[] = [];
            getRows().map((i) => {
                multipleArr.push(i);
                props.onMultipleSelect?.([...multipleArr]);
                return i;
            });
        } else {
            let multipleArr: IGridRow[] = [];
            getRows().map((i) => {
                multipleArr.push(i);
                props.onMultipleSelect?.([]);
                return i;
            });
        }
    }, [allChecked]);

    useEffect(() => {
        document.addEventListener("mouseup", onMouseHoldUp);
        document.addEventListener("mousemove", onMouseHoldMove);
        return () => {
            document.removeEventListener("mouseup", onMouseHoldUp);
            document.removeEventListener("mousemove", onMouseHoldMove);
        };
    });

    useEffect(() => {
        if (props.separator) {
            if (!clientHeight) {
                setClientHeight(getClientHeight(data.length));
                return;
            }
            if (tableRef.current) {
                tableRef.current.style.minHeight = clientHeight + "px";
                tableRef.current.style.maxHeight = clientHeight + "px";
            }
        }
    }, [clientHeight]);

    //автопрокрутка к выбранной строке (из модального окна с ошибками)
    const scrollToRow = (rowIndex: number) => {
        if (!gridRef.current) return;

        const container = tableRef.current;
        const tbody = gridRef.current;
        const rows = tbody.querySelectorAll('tr');

        if (rowIndex >= rows.length) return;

        const targetRow = rows[rowIndex];
        if (!targetRow) return;

        const thead = container?.querySelector('thead');
        const headerHeight = thead?.offsetHeight || 0;

        const containerRect = container?.getBoundingClientRect();
        const rowRect = targetRow.getBoundingClientRect();

        if (container && containerRect) {
            const offsetTop = rowRect.top - containerRect.top + container.scrollTop;
            const rowHeight = rowRect.height;
            const containerHeight = container.clientHeight;

            const isVisible = offsetTop >= container.scrollTop + headerHeight &&
                offsetTop + rowHeight <= container.scrollTop + containerHeight;

            if (!isVisible) {
                const visibleHeight = containerHeight - headerHeight;
                const targetScrollTop = offsetTop - headerHeight - (visibleHeight / 2) + (rowHeight / 2);

                container.scrollTo({
                    top: Math.max(0, targetScrollTop),
                    behavior: 'smooth'
                });
            }
        } else {
            targetRow.scrollIntoView({
                block: 'center',
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        if (props.virtualizedData) {
            const rowIndex = data.findIndex(
                x => x.idGlobal === props.selectById
            );

            if (rowIndex === -1) return;

            const item = data[rowIndex];

            setSelectedItem(item);
            setCurrentTrIndex(rowIndex);
            props.onSelect?.(item);

            const timer = setTimeout(() => {
                const container = tableRef.current;

                if (!container) return;

                const targetTop =
                    rowIndex * ROW_HEIGHT
                    - container.clientHeight / 2
                    + ROW_HEIGHT / 2;

                container.scrollTo({
                    top: Math.max(0, targetTop),
                    behavior: "auto",
                });
            }, 50);

            return () => clearTimeout(timer);
        }

        if (props.selectById && data.length > 0) {
            const rows = getRows();
            const item = rows?.find(x => x.idGlobal === props.selectById);

            if (item) {
                const rowIndex = rows.findIndex(x => x.idGlobal === props.selectById);
                setSelectedItem(item);
                setCurrentTrIndex(rowIndex);
                props.onSelect?.(item);

                const timer = setTimeout(() => {
                    scrollToRow(rowIndex);
                }, 50);
                
                return () => clearTimeout(timer);
            }
        }
    }, [props.selectById, data, props.virtualizedData]);

    // Автопрокрутка вниз при добавлении новой позиции
    useEffect(() => {
        const currentDataLength = data.length;
        const prevDataLength = prevDataLengthRef.current;

        if (currentDataLength > prevDataLength && prevDataLength > 0 && tableRef.current) {
            tableRef.current.scrollIntoView({
                behavior: 'smooth',
            });
            requestAnimationFrame(() => {
                if (tableRef.current) {
                    tableRef.current.scrollTo({
                        top: tableRef.current.scrollHeight,
                        behavior: 'smooth'
                    });
                }
            });
        }

        prevDataLengthRef.current = currentDataLength;
    }, [data]);

    useEffect(() => {
        const findChangedIdGlobal = (): string | null => {
            if (prevPropsDataRef.current.length === 0) return null;
    
            const prevDataMap = new Map<string, any>(
                prevPropsDataRef.current.map(item => [item["idGlobal"], item])
            );
    
            for (const newItem of props.data) {
                if (!prevDataMap.has(newItem["idGlobal"])) {
                    return newItem["idGlobal"];
                }
            }
            
            for (const newItem of props.data) {
                const prevItem = prevDataMap.get(newItem["idGlobal"]);
                if (prevItem) {
                    if (JSON.stringify(prevItem) !== JSON.stringify(newItem)) {
                        return newItem["idGlobal"];
                    }
                }
            }
            return null;
        };
    
        if (sortingStatus && data.length > 0) {
            const propsDataMap = new Map<string, any>(
                props.data.map(item => [item["idGlobal"], item])
            );
    
            const updatedData = data
                .filter(item => propsDataMap.has(item["idGlobal"]))
                .map(item => {
                    const newItem = propsDataMap.get(item["idGlobal"]);
                    if (newItem) {
                        propsDataMap.delete(item["idGlobal"]);
                        return { ...newItem, idRow: item.idRow };
                    }
                    return item;
                });
    
            const newItems = Array.from(propsDataMap.values()).map(x => ({
                ...x,
                idRow: uuidv4()
            }));
    
            const newData = [...updatedData, ...newItems];
            setData(newData);
            
            if (props.autoHighlightOnChange) {
                const changedId = findChangedIdGlobal();
                if (changedId && newData.length > 0) {
                    let changedIndex = newData.findIndex(item => item["idGlobal"] === changedId);
                    if (changedIndex !== -1) {
                        const changedItemData = newData[changedIndex];
                        const changedItem: IGridRow = {
                            idGlobal: changedItemData["idGlobal"],
                            displayName: changedItemData["displayName"] || changedItemData["name"],
                            cells: [],
                            isDeleted: changedItemData["deleted"],
                            isSelected: true,
                        };
                        setCurrentTrIndex(changedIndex);
                        setSelectedItem(changedItem);
                        props.onSelect?.(changedItem);
                    }
                }
            }
        } 
        else if (props.filter.fieldOrderBy) {
            const sortedData = sortArrayByField([...props.data], props.filter.fieldOrderBy, props.filter.orderDesc ?? false);
            let newData = sortedData?.map((x) => ({ ...x, idRow: uuidv4() })) ?? [];
    
            const changedId = lastEditedIdGlobal || findChangedIdGlobal();
            if (changedId && newData.length > 0) {
                const editedIndex = newData.findIndex(item => item["idGlobal"] === changedId);
                if (editedIndex !== -1) {
                    const [editedItem] = newData.splice(editedIndex, 1);
                    newData.push(editedItem);
                }
                setLastEditedIdGlobal(null);
            }
    
            setData(newData);
    
            if (props.autoHighlightOnChange && changedId && newData.length > 0) {
                const changedIndex = newData.findIndex(item => item["idGlobal"] === changedId);
                if (changedIndex !== -1) {
                    const changedItemData = newData[changedIndex];
                    const changedItem: IGridRow = {
                        idGlobal: changedItemData["idGlobal"],
                        displayName: changedItemData["displayName"] || changedItemData["name"],
                        cells: [],
                        isDeleted: changedItemData["deleted"],
                        isSelected: true,
                    };
                    setCurrentTrIndex(changedIndex);
                    setSelectedItem(changedItem);
                    props.onSelect?.(changedItem);
                }
            }

            else if (selectedItem && newData) {
                const newIndex = newData.findIndex(item => item["idGlobal"] === selectedItem.idGlobal);
                if (newIndex !== -1) {
                    const updatedItem = newData[newIndex] as unknown as IGridRow;
                    setCurrentTrIndex(newIndex);
                    setSelectedItem(updatedItem);
                    props.onSelect?.(updatedItem);
                }
            }
        } 
        else {
            let newData = props.data?.map((x) => ({ ...x, idRow: uuidv4() })) ?? [];
    
            const changedId = lastEditedIdGlobal || findChangedIdGlobal();
            if (changedId && newData.length > 0) {
                const editedIndex = newData.findIndex(item => item["idGlobal"] === changedId);
                if (editedIndex !== -1) {
                    const [editedItem] = newData.splice(editedIndex, 1);
                    newData.push(editedItem);
                }
                setLastEditedIdGlobal(null);
            }
    
            setData(newData);
    
            if (props.autoHighlightOnChange && changedId && newData.length > 0) {
                const changedIndex = newData.findIndex(item => item["idGlobal"] === changedId);
                if (changedIndex !== -1) {
                    const changedItemData = newData[changedIndex];
                    const changedItem: IGridRow = {
                        idGlobal: changedItemData["idGlobal"],
                        displayName: changedItemData["displayName"] || changedItemData["name"],
                        cells: [],
                        isDeleted: changedItemData["deleted"],
                        isSelected: true,
                    };
                    setCurrentTrIndex(changedIndex);
                    setSelectedItem(changedItem);
                    props.onSelect?.(changedItem);
                }
            }
            
            else if (selectedItem && newData) {
                const newIndex = newData.findIndex(item => item["idGlobal"] === selectedItem.idGlobal);
                if (newIndex !== -1) {
                    const updatedItem = newData[newIndex] as unknown as IGridRow;
                    setCurrentTrIndex(newIndex);
                    setSelectedItem(updatedItem);
                    props.onSelect?.(updatedItem);
                }
            }
        }
    
        prevPropsDataRef.current = props.data ? [...props.data] : [];
    }, [props.data, props.filter.fieldOrderBy, props.filter.orderDesc]);

    useEffect(() => {
        const selectedRows = rows.filter((x) => x.isSelected);
        const rowsLength = rows.length;

        if (selectedRows.length === rowsLength) setTypeChecked("allChecked");
        else if (selectedRows.length === 0) setTypeChecked("emptyField");
        else if (selectedRows.length < rowsLength) setTypeChecked("indeterminate");
    }, [rows]);
    
    useEffect(() => {
        gridRef?.current?.focus();
        pluginSettingsLoad();
    }, []);

    const isCreatingDefaults = useRef(false);
    const applyPluginSettings = (data: IPluginSettingsDTO) => {
        const normalizeRequest = data.gridColumns.reduce(
            (acc, item) => ({ ...acc, [item.propertyName]: item }),
            {} as Record<string, any>
        );

        const updatedColumns = pluginSettings.columns.map((pluginItem) =>
            normalizeRequest[pluginItem.propertyName]
                ? { ...pluginItem, ...normalizeRequest[pluginItem.propertyName] }
                : pluginItem
        );

        setPluginSettings({
            name: data.name,
            mnemocode: data.mnemocode,
            columns: [...updatedColumns],
            permission: pluginSettings.permission,
            rowHeight: pluginSettings.rowHeight
        });
    };

    const pluginSettingsLoad = () => {
        appCtx.uiApiService.uiPluginSettingsRequest.load(
            pluginSettings.mnemocode,
            userCtx.idGlobal,
            (e) => {
                if (e.respType === "isCompleted") {
                     isCreatingDefaults.current = false;
                    applyPluginSettings(e.data);
                } else {
                    createDefaultPluginSettings();
                }
            }
        );
    };

    const createDefaultPluginSettings = () => {
        isCreatingDefaults.current = true;
        appCtx.uiApiService.uiPluginSettingsRequest.save(
            {
                idUser: userCtx.idGlobal,
                name: pluginSettings.name,
                mnemocode: pluginSettings.mnemocode,
                gridColumns: pluginSettings.columns,
                detailsPlugins: [] as string[],
                rowHeight: pluginSettings.rowHeight ?? GridRowHeightEnum.normal
            },
            () => {
                pluginSettingsLoad();
            }
        );
    };

    function getRows(): IGridRow[] {
        let rows: IGridRow[] = [];

        if (props.data) {
            addMissingFieldsToViewTable(data).forEach((i, index) => {
                let cells: IGridCell[] = [];
                Object.entries(i).forEach((prop) => {
                    try {
                        const propertyName = prop[0];
                        let value = prop[1];
                        const column = pluginSettings.columns.find((item) => item.propertyName === propertyName);
                        if (value && value !== null && value !== "" && column) {
                            switch (column.propertyType) {
                                case "boolean":
                                    value = (value as boolean).toYesNoString();
                                    break;
                                case "date":
                                    if (typeof value !== "string") {
                                        value = (value as DateTime).toF3DateFormat(userCtx);
                                        break;
                                    } else {
                                        value = null;
                                        break;
                                    }
                                case "datetime":
                                    if (typeof value !== "string") {
                                        value = (value as DateTime).toF3DateTimeFormat(userCtx);
                                        break;
                                    } else {
                                        value = null;
                                        break;
                                    }
                            }
                        }

                        const order = column?.order as number;
                        cells.push({
                            value,
                            propertyName,
                            order,
                            visibility: pluginSettings.columns.find((x) => x.propertyName === propertyName)?.visibility as boolean,
                        });
                    } catch (ex) {
                        console.trace(prop[0] + " -> " + prop[1]);
                        console.trace(ex);
                    }
                });
                props?.multipleSelect
                ? rows.push({
                      idGoodsGlobal: i["idGoodsGlobal"] as string,
                      idGlobal: i["idGlobal"] as string,
                      idRow: i["idRow"] as string,
                      displayName: i["displayName"] as string,
                      cells: cells.filter((item) => item.order !== undefined && item.order !== null).sort(compareByOrder),
                      isDeleted: i["deleted"] as boolean,
                      isLocked: i["isLocked"] as boolean,
                      isSelected: props?.selectedItems?.find((x) => x.idRow === i["idRow"]) === undefined ? false : true,
                  })
                :
                rows.push({
                    idGoodsGlobal: i["idGoodsGlobal"] as string,
                    idGlobal: i["idGlobal"] as string,
                    idRow: i["idRow"] as string,
                    displayName: i["displayName"] || (i["name"] as string),
                    cells: cells.filter((item) => item.order !== undefined && item.order !== null).sort(compareByOrder),
                    isDeleted: i["deleted"] as boolean,
                    isLocked: i["isLocked"] as boolean,
                    isSelected: i["idRow"] === selectedItem?.idRow ? true : false,
                });
            });
        }
        return rows;
    }

    function getIsNumberDisabled(cell: IGridCellWithWidth): boolean | undefined {
        if (props.isCrosspharmacy && cell.propertyName === 'actualQuantity')
            return props.isDocumentProcess
        if (props.isCrosspharmacy && cell.propertyName === 'quantity')
            return true
        if (cell.propertyName === 'actualQuantity')
            return true
        if (props.disabledCell) {
            return props.disabledCell?.(cell)
        }

        return (props.documentStateProc ? true : false) || (props.disabledNumberInput ?? false)
    }

    const [currentTrIndex, setCurrentTrIndex] = useState<number>(0);
    useEffect(() => {
        if (selectFirstRowAfterSortRef.current) {
            selectFirstRowAfterSortRef.current = false;
            if (data.length > 0) {
                const firstItem = getRows()[0];
                props.onSelect?.(firstItem);
                setSelectedItem(firstItem);
                setCurrentTrIndex(0);
            } else {
                props.onSelect?.(undefined);
                setSelectedItem(undefined);
            }
        } else if (props.autoSelect && data.length > 0) {
            getRows().map((item, index) => {
                if (index === currentTrIndex) {
                    props.onSelect?.(item);
                    setSelectedItem(item);
                }
            });
        } else if (props.autoSelectFirst && data.length > 0) {
            props.onSelect?.(getRows()[0]);
            setSelectedItem(getRows()[0]);
        } else if (!sortingStatus && selectedItem && data.length > 0) {
            const rows = getRows();
            const foundIndex = rows.findIndex(row => row.idGlobal === selectedItem.idGlobal);
            if (foundIndex !== -1) {
                const updatedItem = rows[foundIndex];
                setSelectedItem(updatedItem);
                setCurrentTrIndex(foundIndex);
                props.onSelect?.(updatedItem);
            } else {
                props.onSelect?.(undefined);
                setSelectedItem(undefined);
            }
        } else {
            props.onSelect?.(undefined);
            setSelectedItem(undefined);
        }
    }, [data]);

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current && (props.autoSelect || props.autoSelectFirst) && data.length > 0) {
            const item = getRows()[0];
            props.onSelect?.(item);
            setSelectedItem(item);
            setCurrentTrIndex(0);
            isFirstRender.current = false;
        } else if (!isFirstRender.current && (props.autoSelect && !props.autoSelectFirst) && data.length > 0) {
            const lastIndex = data.length - 1;
            const lastItem = getRows()[lastIndex];
            props.onSelect?.(lastItem);
            setSelectedItem(lastItem);
            setCurrentTrIndex(lastIndex);
        } else if (!props.autoSelectFirst) {
            props.onSelect?.(undefined);
            setSelectedItem(undefined);
        }
    }, [data.length]);

    //context menu
    function getContextId(type: "header" | "row", baseId: string) {
        return `ctxMenu_${type}_${baseId}`;
    }

    useEffect(() => {
        const handler = () => setGridHeaderContextMenuVisible(false);
        if (gridHeaderContextMenuVisible === true) {
            let ctxMenu = document.getElementById(getContextId("header", props.gridId)) as HTMLElement;
            if (ctxMenu) {
                ctxMenu.onmouseleave = handler;
                return ctxMenu.removeEventListener("mouseleave", handler);
            }
        }
    }, [gridHeaderContextMenuVisible]);

    useEffect(() => {
        const handler = () => setGridRowContextMenuVisible(false);
        if (gridRowContextMenuVisible === true) {
            let ctxMenu = document.getElementById(getContextId("row", props.gridId)) as HTMLElement;
            if (ctxMenu) {
                ctxMenu.onmouseleave = handler;
                return ctxMenu.removeEventListener("mouseleave", handler);
            }
        }
    }, [gridRowContextMenuVisible]);

    useEffect(() => {
        if (gridRowContextMenu) {
            let ctxMenu = document.getElementById(getContextId("row", props.gridId)) as HTMLElement;

            if (ctxMenu) {
                ctxMenu.onmouseleave = () => setGridRowContextMenu(undefined);
                return ctxMenu.removeEventListener("mouseleave", () => setGridRowContextMenu(undefined));
            }
        }
    }, [gridRowContextMenu]);

    //context menu
    useEffect(() => {
        if (gridColumnsToSave.save) {
            appCtx.uiApiService.uiPluginSettingsRequest.save(
                {
                    idUser: userCtx.idGlobal,
                    name: pluginSettings.name,
                    mnemocode: pluginSettings.mnemocode,
                    gridColumns: gridColumnsToSave.columns,
                    detailsPlugins: [] as string[],
                    rowHeight: pluginSettings.rowHeight ?? GridRowHeightEnum.normal
                },
                () => {
                    setPluginSettings({ ...pluginSettings, columns: gridColumnsToSave.columns });
                    setGridColumnsToSave({ ...gridColumnsToSave, save: false });
                }
            );
        }
    }, [gridColumnsToSave]);

    const savePluginSettingsWidth = () => {
        let grid = document.getElementById(props.gridId) as HTMLElement;
        let columnCells = grid.getElementsByClassName(styles.gridColumnCell);
        const newState: IGridColumn[] = [...pluginSettings.columns];
        let changed: boolean = false;
        for (var i = 0; i < columnCells.length; i++) {
            const pName = columnCells[i].getAttribute("data-property-name");
            const column = newState.find((x) => x.propertyName === pName) as IGridColumn;
            if (column?.width !== columnCells[i].getBoundingClientRect()?.width) {
                changed = true;
                if (column?.width) {
                    column.width = columnCells[i].getBoundingClientRect()?.width;
                }
            }
        }
        if (changed && pluginSettings.columns) {
            setGridColumnsToSave({ columns: newState, save: true });
        }
    };

    function renderSortIcon(item: IGridColumn) {
        if (props.filter.fieldOrderBy === item.propertyName && props.filter.orderDesc) return <DownIcon className={classNames(styles.sortIcon, styles.sortIcon_Selected)} />;
        if (props.filter.fieldOrderBy === item.propertyName && !props.filter.orderDesc) return <UpIcon className={classNames(styles.sortIcon, styles.sortIcon_Selected)} />;

        return <SortIcon className={styles.sortIcon} />;
    }

    const wrapRef1 = useRef<HTMLDivElement>(null);
    const wrapRef2 = useRef<HTMLDivElement>(null);
    const visibleHook = useRef<HTMLDivElement>(null);

    function getToolTipTitle(cell: IGridCellWithWidth): string {
        if (!props.maxDiscountValue?.[cell.propertyName] ) {
          let itemValidation = props.itemsValidation?.find(x => x.idGlobal === cell.idGlobal);
          if (itemValidation?.err) return itemValidation.message;
      
          let itemFilter = props.itemsFilter?.find(x => x.idItem === cell.idGlobal);
          if (itemFilter?.quantityMax) return `Доступно всего: ${itemFilter.quantityMax}`;
        }
        return "";
    }

    const checkUpScroll = (currentScrollTop: number): boolean => {
        if (tableRef.current?.scrollHeight) {
            return (!wheelDown || currentScrollTop < lastScrollPosition) &&
                pageNumber.pageNumber > 2;
        } else {
            return false;
        }
    };

    const checkDownScroll = (currentScrollTop: number): boolean => {
        if (tableRef.current?.scrollHeight) {
            return (wheelDown || currentScrollTop >= lastScrollPosition) &&
                pageNumber.pageNumber <= Math.ceil(props.totalCount / props.filter.numberPerPage);
        } else {
            return false;
        }
    };

    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [currentTdIndex, setCurrentTdIndex] = useState<number>(0);
    useEffect(() => {
        if (selectedRow) {
            const rowIndex  = rows.findIndex((row) => row.idGlobal === selectedItem?.idGlobal) == 0 ? currentTrIndex : rows.findIndex((row) => row.idGlobal === selectedItem?.idGlobal)

            const nextElement = gridRef.current
            if (nextElement && rowIndex !== -1) {
                const currentTr = nextElement?.querySelectorAll('tr')[rowIndex + 1]
                const currentTD = currentTr?.querySelectorAll('td')[currentTdIndex]
                const currentDiv = currentTD?.querySelector('input')
                
                setSelectedItem(rows[rowIndex + 1]);
                props.onSelect?.(rows[rowIndex + 1]); 
                setCurrentTrIndex(rowIndex + 1)
                currentDiv?.select();
            }
        }
    }, [selectedRow])

    function maxValue(cell: IGridCellWithWidth): number | undefined {
        if (props?.maxDiscountValue) {
            return props?.maxDiscountValue[cell.propertyName];
        } else return undefined;
    }       

    const getStyleBorderTrLocal = (item: IChangeableGridRow): string => {
        const options: IGridStyleOptions = {
            documentType: props.documentType,
            sysOptionsKizValidationType: props.sysOptionsKizValidationType,
            customKizControl: props.customKizControl,
            getIsLs: (item) => props.items?.find(x => x.idGlobal === item.idGlobal)?.isLs ?? false
        };

        return getStyleBorderTr(item as IGridStyleItem, options);
    };

    const search = (value: string) => {
        if (value.length > 0) {

            props.filter.pageNumber = 1
            setPageNumber({
                pageNumber: props.filter.pageNumber,
                prevPageNumber: props.filter.pageNumber,
            });
            props.dispatchFilter?.({
                type: "addColumnFilter", 
                payload: { 
                    name: "goodsName", 
                    value: `%${value}%`, 
                    operator: "Like" 
                }
            });
        } else {
            props.dispatchFilter?.({ type: "deleteColumnFilter", payload: "goodsName" })
        }
    }

    const tBodyRows: IChangeableGridRow[] =
        rows.filter(element => {
            let itСheck: boolean = true;
            searchRowsArray.forEach((el) => {
                const cell = element?.cells.find(x => x.propertyName === el.propertyName);

                switch (cell?.propertyType) {
                    case 'string': 
                    case 'date':
                    case 'datetime':
                        if (cell.value === null || cell.value === undefined || !String(cell.value).toLowerCase().includes(el.value.toLowerCase())) {
                            itСheck = false;
                        }
                        break
                    case 'number':
                    case 'decimal':
                        if (!String(cell.value).includes(el.value)) {
                            itСheck = false;
                        }
                        break
                    case 'boolean':
                        let isSearchingTrue: boolean = /^[да]*$/.test(el?.value.toLowerCase());
                        let isSearchingFalse: boolean = /^[нет]*$/.test(el?.value.toLowerCase());
                        if (isSearchingTrue && (cell.value === false || cell.value === null || cell.value === undefined)) {
                            itСheck = false;
                        } else if (isSearchingFalse && (cell.value === 'Да' || cell.value === true)) {
                            itСheck = false;
                        }
                        break
                    default:
                        itСheck = false;
                        break
                }
            })
            return itСheck;
        })

    const OVERSCAN_COUNT = 2;

    const prevStartIntervalRef = useRef<number>(0);
    const scrollRAFRef = useRef<number | null>(null);
    const isScrollingRef = useRef<boolean>(false);

    const visibleRowsData = useMemo(() => {
        if (!props.virtualizedData) return tBodyRows;
        
        const safeStart = Math.max(0, startInterval);
        const start = Math.max(0, Math.min(
            safeStart - OVERSCAN_COUNT,
            tBodyRows.length - visibleRows - 1
        ));
        const end = Math.min(start + visibleRows + 1 + OVERSCAN_COUNT * 2, tBodyRows.length);
        
        return tBodyRows.slice(start, end);
    }, [tBodyRows, startInterval, visibleRows, props.virtualizedData]);

    useEffect(() => {
        if (!selectFirstRowAfterSearchRef.current) return;

        selectFirstRowAfterSearchRef.current = false;
        const firstItem = visibleRowsData[0];
        props.onSelect?.(firstItem);
        setSelectedItem(firstItem);
        setCurrentTrIndex(0);
    }, [searchRowsArray]);

    const getStyleTd = (width: string, minWidth: string) => {
        return { width: width, minWidth: minWidth, height: pluginSettings.rowHeight }
    }

    useEffect(() => {
        handleSortByAlerts(sortByAlertsEnabled);
    }, [sortByAlertsEnabled]);

    useEffect(() => {
        // Если сортировка не по alerts - снимаем чекбокс
        if (props.filter?.fieldOrderBy && props.filter.fieldOrderBy !== 'alerts') {
            setSortByAlertsEnabled(false);
        }
    }, [props.filter?.fieldOrderBy]);

    const handleSortByAlerts = (alertsSortOrder) => {
        const sortedData = [...data].sort((a, b) => {
            const hasAlertsA = a.alerts && a.alerts.length > 0;
            const hasAlertsB = b.alerts && b.alerts.length > 0;

            const scoreA = hasAlertsA ? 1 : 0;
            const scoreB = hasAlertsB ? 1 : 0;

            return alertsSortOrder ? scoreB - scoreA : scoreA - scoreB;
        });
        setData(sortedData);
    };

    const handleCheckboxChange = () => {
        setSortByAlertsEnabled(!sortByAlertsEnabled);
    };

    const handleVirtualScroll = useCallback((scrollTarget: HTMLDivElement) => {
        if (isScrollingRef.current) return;
        isScrollingRef.current = true;

        if (scrollRAFRef.current !== null) {
            cancelAnimationFrame(scrollRAFRef.current);
        }

        scrollRAFRef.current = requestAnimationFrame(() => {
            const scrollTop = Math.max(0, scrollTarget.scrollTop);
            const containerHeight = scrollTarget.clientHeight;
            const scrollHeight = scrollTarget.scrollHeight;

            // Проверка на верхнюю границу
            if (scrollTop < 2) {
                if (prevStartIntervalRef.current !== 0) {
                    prevStartIntervalRef.current = 0;
                    setStartInterval(0);
                }
                isScrollingRef.current = false;
                scrollRAFRef.current = null;
                return;
            }

            // Проверка на нижнюю границу
            if (scrollTop + containerHeight >= scrollHeight - 2) {
                const maxStart = Math.max(0, data.length - visibleRows - 1);
                if (prevStartIntervalRef.current !== maxStart) {
                    prevStartIntervalRef.current = maxStart;
                    setStartInterval(maxStart);
                }
                isScrollingRef.current = false;
                scrollRAFRef.current = null;
                return;
            }

            const newStart = Math.floor(scrollTop / ROW_HEIGHT);
            const bounded = Math.max(0, Math.min(
                newStart,
                data.length - visibleRows - 1
            ));

            if (prevStartIntervalRef.current !== bounded) {
                prevStartIntervalRef.current = bounded;
                setStartInterval(bounded);
            }

            isScrollingRef.current = false;
            scrollRAFRef.current = null;
        });
    }, [data.length, visibleRows, ROW_HEIGHT]);

    useEffect(() => {
        return () => {
            if (scrollRAFRef.current !== null) {
                cancelAnimationFrame(scrollRAFRef.current);
            }
        };
    }, []);

    return (
        <>
            <div className={styles.gridWrapper} ref={wrapRef2}>
                <FlexRow>
                    {props.dispatchFilter && <FlexColumn ref={props.tourRefs?.search}>
                        <FlexRow>
                            <TextInput
                                label=''
                                placeholder={t("general.searchDocument")}
                                inline
                                style={{ width: 315, marginLeft: -15 }}
                                onKeyDown={(e) => {
                                    switch(e.key) {
                                        case "Enter": {
                                            search(e.currentTarget?.value);
                                        }
                                    }
                                }}
                                searchButtonShow
                                onChange={(value: string) => {
                                    setSearchDocumentValue(value);
                                }}
                                searchButtonOnClick={() => {
                                    search(searchDocumentValue);
                                }}
                            >
                            </TextInput>
                        </FlexRow>
                    </FlexColumn>}
                    <FlexColumn>
                        <div className={styles.gridWrapper_gridSettings}>
                            <div>
                                {baseT("quantityPositions")}: <b>{showQuantityPositions()}</b>
                            </div> 
                            <CheckBox
                                id="sortingStatus"
                                label={baseT("sortingStatus")}
                                defaultChecked={sortingStatus}
                                onChanged={(checked) => setSortingStatus(checked)}
                            />
                            {props.isShowAll !== undefined ? <CheckBox label={baseT("showAll")} onChanged={() => setShowAll(!showAll)}/> : <></>}  
                            {props.enableSortByAlerts !== undefined && (
                                <AntCheckbox
                                    checked={sortByAlertsEnabled}
                                    onChange={handleCheckboxChange}
                                    style={{marginLeft: 10}}
                                >
                                    {baseT("errorsOnTop")}
                                </AntCheckbox>
                            )}
                            {!props.hideSettingstButton && (
                                <div className={styles.buttonsContainer}>
                                    <div className={styles.buttonLink} onClick={() => setShowGridHeaderSettings(true)}>{baseT("gridSettings")}</div>
                                </div>
                            )}
                        </div>
                    </FlexColumn>
                </FlexRow>
                {props.sendRequest && (
                    <div className={styles.spin}>
                        {" "}
                        <Spinner xl />
                    </div>
                )}
                <div
                    style={props.virtualizedData ? virtualizedStyles : undefined}
                    className={classNames(styles.gridWrapper__tables, props.sendRequest ? styles.gridWrapper__tables__disabledScroll : "")}
                    ref={tableRef}
                    data-grid="true"
                    onWheel={(ev) => {
                        if(props.virtualizedData) {
                            return;
                        }
                        if (ev.deltaY < 0) {
                            setWheelDown(false);
                        } else {
                            setWheelDown(true);
                        }
                    }}
                    onScroll={(scroll) => {
                        if (suppressScrollEvent.current) return;

                        const targetDiv: HTMLDivElement = scroll.target as HTMLDivElement;

                        if (props.virtualizedData) {
                            handleVirtualScroll(targetDiv);
                            return;
                        }

                        if (targetDiv === wrapRef1.current && tableRef.current) {
                            tableRef.current.scrollLeft = targetDiv.scrollLeft;
                        } else if (targetDiv === tableRef.current && wrapRef1.current) {
                            wrapRef1.current.scrollLeft = targetDiv.scrollLeft;
                        }

                        if (!props.hiddenPagination?.hiddenNumberPage) {

                            const scrollTop: number = scroll.currentTarget.scrollTop;
                            const scrollHeight: number = scroll.currentTarget.scrollHeight;
                            const clientHeight: number = scroll.currentTarget.clientHeight;
                            const conditionScroll: boolean = (scrollHeight - scrollTop) === clientHeight ||
                                Math.round(scrollHeight - scrollTop) === clientHeight ||
                                Math.round(scrollHeight - scrollTop - 1) === clientHeight ||
                                Math.round(scrollHeight - scrollTop + 1) === clientHeight;

                            if (checkDownScroll(scrollTop)) {
                                if (
                                    tableRef.current?.scrollHeight &&
                                    pageNumber.pageNumber < Math.ceil(props.totalCount / props.filter.numberPerPage) &&
                                    conditionScroll
                                ) {

                                    setPageNumber({
                                        pageNumber: pageNumber.pageNumber + 1,
                                        prevPageNumber: pageNumber.pageNumber,
                                    });

                                    if (props?.onPageLoad) {

                                        props.filter.pageNumber++;
                                        props.onPageLoad("down", (verticalPivot, part) => {
                                            const param = verticalPivot === 'top' ?
                                                { top: tableRef.current?.scrollTop as number / part } :
                                                { top: tableRef.current?.scrollHeight as number / part }

                                            tableRef.current?.scrollTo(param);
                                        });
                                    } else if (props?.dataProvider) {

                                        const el = tableRef.current;
                                        if (el) {
                                            const lockedLeft = el.scrollLeft;
                                            paginationScrollLeft.current = lockedLeft;
                                            let rafId: number | null = null;
                                            const lock = () => {
                                                if (el.scrollLeft !== lockedLeft) el.scrollLeft = lockedLeft;
                                                rafId = requestAnimationFrame(lock);
                                            };
                                            rafId = requestAnimationFrame(lock);
                                            paginationScrollLockCleanup.current = () => {
                                                if (rafId !== null) cancelAnimationFrame(rafId);
                                            };
                                        }

                                        props.dataProvider.getView({ ...props.filter, pageNumber: pageNumber.pageNumber + 1 }, (newRows: TViewDTO[]) => {
                                            if (pageNumber.pageNumber <= Math.ceil(props.totalCount / props.filter.numberPerPage)) {
                                                if (data.length >= props.filter.numberPerPage * 2) {
                                                    tableRef.current?.scrollTo({ top: tableRef.current?.scrollTop / 2, left: tableRef.current?.scrollLeft });
                                                    setData([...data, ...newRows.map((x) => ({ ...x, idRow: uuidv4() }))].slice(props.filter.numberPerPage));
                                                } else {
                                                    setData([...data, ...newRows.map((x) => ({ ...x, idRow: uuidv4() }))]);
                                                }
                                            }
                                        });
                                    }
                                }
                            } else if (checkUpScroll(scrollTop)) {
                                if (scroll.currentTarget.scrollTop < 5 || scroll.currentTarget.scrollTop == 0) {

                                    // Проверка на прогрузку вне диапазона страниц
                                    if (pageNumber.pageNumber - 2 > 0) {

                                        setPageNumber({
                                            pageNumber: pageNumber.pageNumber - 1,
                                            prevPageNumber: pageNumber.pageNumber,
                                        });

                                        if (props?.onPageLoad) {

                                            props.filter.pageNumber--;
                                            props.onPageLoad("up", (verticalPivot, part) => {
                                                const param = verticalPivot === 'top' ?
                                                    { top: tableRef.current?.scrollTop as number / part } :
                                                    { top: tableRef.current?.scrollHeight as number / part }

                                                tableRef.current?.scrollTo(param);
                                            });

                                        } else if (props?.dataProvider) {

                                            const elUp = tableRef.current;
                                            if (elUp) {
                                                const lockedLeft = elUp.scrollLeft;
                                                paginationScrollLeft.current = lockedLeft;
                                                let rafId: number | null = null;
                                                const lock = () => {
                                                    if (elUp.scrollLeft !== lockedLeft) elUp.scrollLeft = lockedLeft;
                                                    rafId = requestAnimationFrame(lock);
                                                };
                                                rafId = requestAnimationFrame(lock);
                                                paginationScrollLockCleanup.current = () => {
                                                    if (rafId !== null) cancelAnimationFrame(rafId);
                                                };
                                            }

                                            props.dataProvider.getView({ ...props.filter, pageNumber: pageNumber.pageNumber - 1 }, (newRows: TViewDTO[]) => {
                                                tableRef.current?.scrollTo({ top: 200, left: tableRef.current?.scrollLeft });
                                                if (data.length < props.filter.numberPerPage * 2) {
                                                    setData([...newRows.map((x) => ({ ...x, idRow: uuidv4() })), ...data.slice(0, data.length - props.filter.numberPerPage)]);
                                                } else {
                                                    setData([...newRows.map((x) => ({ ...x, idRow: uuidv4() })), ...data.slice(0, props.filter.numberPerPage)]);
                                                }
                                            });
                                        }
                                    }
                                }
                            }

                            lastScrollPosition = scroll.currentTarget.scrollTop;
                        }
                    }
                    }
                >   
                    <table id={props.gridId} className={styles.gridTable}>
                        <thead
                            className={styles.gridColumnsHeader}
                            onContextMenu={(e) => {
                                if (process.env.REACT_APP_SHOW_GRID_CONTEXT === "true") {
                                    e.preventDefault();
                                    const menuWidth = 145;
                                    const menuHeight = 70;

                                    const modalPortal = document.getElementById('react-portal-modal-container');
                                    const modalOverlay = modalPortal?.querySelector('[class*="BaseModalWindow_modalOverlay"]');
                                    const modalWindow = modalOverlay?.querySelector('[class*="BaseModalWindow_modalEditValues"]');

                                    if (!modalWindow) {
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        const showOnLeft = e.clientX > viewportWidth - menuWidth;
                                        const showOnTop = e.clientY > viewportHeight - menuHeight;

                                        setHeaderCtxPosX(showOnLeft ? e.clientX - menuWidth : e.clientX);
                                        setHeaderCtxPosY(showOnTop ? e.clientY - menuHeight : e.clientY);
                                        setGridHeaderContextMenuVisible(true);
                                        return;
                                    };

                                    if (modalWindow) {
                                        const modalRect = modalWindow.getBoundingClientRect();

                                        const modalStyle = window.getComputedStyle(modalWindow);

                                        const paddingLeft = parseFloat(modalStyle.paddingLeft) || 0;
                                        const paddingTop = parseFloat(modalStyle.paddingTop) || 0;

                                        const availableWidth = modalRect.width - paddingLeft - (parseFloat(modalStyle.paddingRight) || 0);
                                        const availableHeight = modalRect.height - paddingTop - (parseFloat(modalStyle.paddingBottom) || 0);

                                        const xInModal = e.clientX - modalRect.left - paddingLeft;
                                        const yInModal = e.clientY - modalRect.top - paddingTop;

                                        const showOnLeft = xInModal > availableWidth - menuWidth;
                                        const showOnTop = yInModal > availableHeight - menuHeight;

                                        setHeaderCtxPosX(showOnLeft ? xInModal - menuWidth : xInModal);
                                        setHeaderCtxPosY(showOnTop ? yInModal - menuHeight : yInModal);
                                    } else {
                                        setHeaderCtxPosX(e.clientX);
                                        setHeaderCtxPosY(e.clientY);
                                    }
                                    setGridHeaderContextMenuVisible(true);
                                }
                            }}
                            style={{height: pluginSettings.rowHeight}}
                        >
                            <tr className={styles.gridColumn} onMouseUp={(e) => savePluginSettingsWidth()}>

                                {props.multipleSelect && (
                                    <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "45px", minWidth: "45px" }}>
                                        <CheckBoxMultiple checked={typeChecked} onChange={() => setAllChecked(!allChecked)} />
                                    </td>
                                )}

                                {props.numbering && (
                                    <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "55px", minWidth: "55px" }}>
                                        <span className={styles.gridColumnHeaderName}>{baseT("number")}</span>
                                    </td>
                                )}

                                {props.isEditKizs && (
                                    <td draggable={false} className={styles.gridColumnCell} style={{ width: "75px", minWidth: "75px" }}>
                                        <span className={styles.gridColumnHeaderName}>{baseT("idError")}</span>
                                    </td>
                                )}

                                <>
                                    {pluginSettings.columns.sort(compareByOrder).map((item, index) => {
                                        let filtered = props.filter.columnFilters.filter((i) => i.name === item.propertyName && i.invisible === false).length > 0;
                                        return (
                                            item.visibility && (
                                                <TableHeader
                                                    key={item.propertyName}
                                                    index={index}
                                                    draggable={true}
                                                    item={item}
                                                    filtered={filtered}
                                                    pluginSettings={pluginSettings}
                                                    setGridColumnsToSave={setGridColumnsToSave}
                                                    onResizeStart={() => {
                                                        const el = tableRef.current;
                                                        if (!el) return;
                                                        const lockedScrollLeft = el.scrollLeft;
                                                        savedScrollLeft.current = lockedScrollLeft;
                                                        let rafId: number | null = null;
                                                        const lock = () => {
                                                            if (el.scrollLeft !== lockedScrollLeft) {
                                                                el.scrollLeft = lockedScrollLeft;
                                                            }
                                                            rafId = requestAnimationFrame(lock);
                                                        };
                                                        rafId = requestAnimationFrame(lock);
                                                        scrollLockCleanup.current = () => {
                                                            if (rafId !== null) cancelAnimationFrame(rafId);
                                                        };
                                                    }}
                                                    onReorderEnd={() => {
                                                        const el = tableRef.current;
                                                        if (!el) return;
                                                        const lockedScrollLeft = el.scrollLeft;
                                                        savedScrollLeft.current = lockedScrollLeft;
                                                        let rafId: number | null = null;
                                                        const lock = () => {
                                                            if (el.scrollLeft !== lockedScrollLeft) {
                                                                el.scrollLeft = lockedScrollLeft;
                                                            }
                                                            rafId = requestAnimationFrame(lock);
                                                        };
                                                        rafId = requestAnimationFrame(lock);
                                                        scrollLockCleanup.current = () => {
                                                            if (rafId !== null) cancelAnimationFrame(rafId);
                                                        };
                                                    }}
                                                    sorting={!props.localSortingData}
                                                    onSort={(value) => {
                                                        const newSortState = {
                                                            fieldOrderBy: value.propertyName,
                                                            orderDesc: props.filter.fieldOrderBy === value.propertyName ? !props.filter.orderDesc : true
                                                        };
                                                        const sortedData = sortArrayByField([...data], newSortState.fieldOrderBy, newSortState.orderDesc);
                                                        selectFirstRowAfterSortRef.current = true;
                                                        setData(sortedData);

                                                        if (!props.localSortingData) {
                                                            props.onSort(value);
                                                        }
                                                    }}
                                                    searching={props.searching}
                                                    onSearch={(value, column) => {
                                                        selectFirstRowAfterSearchRef.current = true;
                                                        setSearchRows({
                                                            value,
                                                            order: column.order,
                                                            propertyName: column.propertyName
                                                        });
                                                    }}
                                                    renderSortIcon={renderSortIcon}
                                                    onFilterDelete={props.onFilterDelete}
                                                    cls={{ tD: styles.gridColumnCell, tooltip: styles.gridColumnHeaderName, sortingDiv: styles.gridColumnCellButtons, sortingDivButton: styles.gridSortButton, searchDropDivButton: styles.searchDropDivButton, filteredDiv: styles.gridFilterButton }}
                                                    onColumnReorder={(updatedColumns) => {
                                                        setPluginSettings(prev => ({
                                                            ...prev,
                                                            columns: updatedColumns
                                                        }));
                                                    }}
                                                />
                                            )
                                        );
                                    })}
                                </>
                            </tr>
                        </thead>
                        <div className={styles.virtualizedBody}>
                            <tbody
                                className={styles.gridRowsGroup} ref={gridRef}
                                style={{
                                    paddingTop: virtualPadding.paddingTop,
                                    paddingBottom: virtualPadding.paddingBottom,
                                }}>
                                {
                                    visibleRowsData
                                        .map((item, rowIndex) => {
                                            const cells = item.cells;
                                            const displayColumns = (gridColumnsToSave.save && gridColumnsToSave.columns.length > 0)
                                                ? gridColumnsToSave.columns
                                                : pluginSettings.columns;
                                            let orderedCells: IGridCellWithWidth[] = [];
                                            for (let i = 0; i < cells.length; i++) {
                                                orderedCells.push({
                                                    ...cells[i],
                                                    idGlobal: item.idGlobal,
                                                    order: displayColumns.find((item) => item.propertyName === cells[i].propertyName)?.order as number,
                                                    width: displayColumns.find((item) => item.propertyName === cells[i].propertyName)?.width as number,
                                                });
                                            }
                                            orderedCells = orderedCells.sort(compareByOrder);
                                            return (
                                                <tr style={{ border: getStyleBorderTrLocal(item), height: pluginSettings.rowHeight }}
                                                    onContextMenu={(e) => {
                                                        if (process.env.REACT_APP_SHOW_GRID_CONTEXT === "true") {
                                                            e.preventDefault();
                                                            setGridRowContextMenu(props.onGridRowContextMenuMouseClick?.(item, { x: e.pageX - 5, y: e.pageY - 5 }));
                                                        }
                                                        if (selectedItem) {
                                                            setHeaderCtxPosX(e.pageX);
                                                            setHeaderCtxPosY(e.pageY);
                                                            setGridRowContextMenuVisible(true);
                                                        }
                                                    }}
                                                    key={item.idGlobal}
                                                    tabIndex={-1}
                                                    data-item-id={item.idGlobal}
                                                    className={classNames(
                                                        styles.gridRow,
                                                        props.classNameBodyTr,
                                                        item.isSelected ? styles.gridRowSelected : null,
                                                        item.isDeleted ? styles.gridRowDeleted : null,
                                                        item.absentInGC ? styles.gridRowAbsentInGC : null,
                                                        props.getStyleRow?.(item)
                                                    )}
                                                    onClick={(e) => {
                                                        if (props?.multipleSelect) {
                                                            multiSelectScrollLeft.current = tableRef.current?.scrollLeft ?? null;
                                                            if (props?.selectedItems?.length === 0) {
                                                                props.onMultipleSelect?.([item]);
                                                            }
                                                            if (props?.selectedItems) {
                                                                props?.selectedItems?.find((x) => x.idGlobal === item.idGlobal) === undefined && props.onMultipleSelect?.([...props.selectedItems, item]);
                                                            }
                                                            if (item.isSelected && props?.selectedItems) {

                                                                const newSelectedArray = props?.selectedItems?.filter((x) => x.idGlobal !== item.idGlobal);
                                                                props.onMultipleSelect?.([...newSelectedArray]);
                                                            }
                                                        } else {
                                                            if (!props.onSelect) {
                                                                return;
                                                            }
                                                            if (item.isSelected) {
                                                                let target = ((e.target as Element).className as unknown as SVGAnimatedString);
                                                                const isTargetSvgMini = target.baseVal?.includes("svgMini");
                                                                if (!isTargetSvgMini) {
                                                                    selectRow(undefined);
                                                                    props.onMultipleSelect?.([]);
                                                                    props.onSelect?.(undefined);
                                                                }
                                                            } else {
                                                                selectRow(item);
                                                                setCurrentTrIndex(rowIndex);
                                                                props.onSelect?.(item);
                                                                props.onMultipleSelect?.([item]);
                                                            }
                                                        }
                                                    }}
                                                    onKeyDown={(eKeyPress) => {
                                                        switch (eKeyPress.key) {
                                                            case "ArrowDown":
                                                            case "Tab":
                                                                let lastRow;
                                                                for (let i = 0; i < rows.length; i++) {
                                                                    if (rows[i].idGlobal === selectedItem?.idGlobal) {
                                                                        if (i + 1 < rows.length) {
                                                                            selectRow(rows[i + 1]);
                                                                            props.onSelect?.(rows[i + 1]);
                                                                        } else lastRow = i + 1;
                                                                    }
                                                                }
                                                                if (!props.hiddenPagination) {
                                                                    if (lastRow == rows.length && props.totalCount / props.filter.numberPerPage > props.filter.pageNumber) {
                                                                        props.filter.pageNumber++;
                                                                        props.onPageNumberChange(props.filter.pageNumber);
                                                                    }
                                                                }
                                                                let nextElement = eKeyPress.currentTarget.nextElementSibling as HTMLElement;
                                                                if (nextElement != null) nextElement.focus();
                                                                break;

                                                            case "ArrowUp":
                                                                let firstRow;
                                                                for (let i = data.length - 1; i >= 0; i--) {
                                                                    if (rows[i].idGlobal === selectedItem?.idGlobal) {
                                                                        if (i - 1 >= 0) {
                                                                            selectRow(rows[i - 1]);
                                                                            props.onSelect?.(rows[i - 1]);
                                                                        } else firstRow = i - 1;
                                                                    }
                                                                }
                                                                if (firstRow == -1 && props.filter.pageNumber != 1) {
                                                                    props.filter.pageNumber--;
                                                                    props.onPageNumberChange(props.filter.pageNumber);
                                                                }
                                                                break;

                                                            case "ArrowRight":
                                                                if (props.totalCount / props.filter.numberPerPage > props.filter.pageNumber && props.hiddenPagination?.hiddenNumberPage) {
                                                                    props.filter.pageNumber++;
                                                                    props.onPageNumberChange(props.filter.pageNumber);
                                                                }
                                                                break;

                                                            case "ArrowLeft":
                                                                if (props.filter.pageNumber > 1 && props.hiddenPagination?.hiddenNumberPage) {
                                                                    props.filter.pageNumber--;
                                                                    props.onPageNumberChange(props.filter.pageNumber);
                                                                }
                                                                break;

                                                            case "Enter":
                                                                setViewState("edit");
                                                                if (props.onEnter) {
                                                                    selectedItem && item && props.onEnter(item);
                                                                }
                                                                break;
                                                            case "Delete":
                                                                props.actionGridRow?.delete?.();
                                                                break;
                                                            default:
                                                                break;
                                                        }
                                                    }}
                                                    onDoubleClick={() => {
                                                        !props.multipleSelect && props.onDoubleClick?.(item);
                                                    }}
                                                >
                                                    {props.multipleSelect && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("45px", "45px")}>
                                                            <input type="checkbox" checked={item.isSelected} readOnly />
                                                        </td>
                                                    )}

                                                    {props.numbering && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("55px", "55px")}>
                                                            {props.isSortDataReverse ? data.length - rowIndex : rowIndex + 1}
                                                        </td>
                                                    )}

                                                    {props.isEditKizs && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("75px", "75px")}>
                                                            {item.cells.find((x) => x["propertyName"] === "idError")?.value}
                                                        </td>
                                                    )}
                                                    {orderedCells.map((cell, index) => {
                                                        let takeCurrentTdIndex = pluginSettings.columns
                                                            .filter(el => el.visibility)
                                                            .findIndex(el => el.propertyName === cell.propertyName)

                                                        const propsArr = [props.multipleSelect, props.numbering, props.isEditKizs]
                                                        propsArr.forEach(prop => {
                                                            if (prop) {
                                                                takeCurrentTdIndex++;
                                                            }
                                                        });

                                                        return (
                                                            cell.visibility && (
                                                                <td key={index} className={styles.gridRowCell} style={{ width: cell.width, minWidth: cell.width, height: pluginSettings.rowHeight }} data-order-number={cell.order} data-property-name={cell.propertyName}>
                                                                    {cell.changeable && item.absentInGC !== false ? (
                                                                        (() => {
                                                                            if (props.renderCell) {
                                                                                const rowHeight = pluginSettings.rowHeight;
                                                                                const customRender = props.renderCell(cell, item, (value) => {
                                                                                    props.onChangeData?.({
                                                                                        propertyName: cell.propertyName,
                                                                                        value: value,
                                                                                        idGlobal: cell.idGlobal,
                                                                                    });
                                                                                    setLastEditedIdGlobal(cell.idGlobal);
                                                                                },
                                                                                    rowHeight
                                                                                );

                                                                                if (customRender !== null && customRender !== undefined) {
                                                                                    return customRender;
                                                                                }
                                                                            }
                                                                            switch (cell.propertyType) {
                                                                                case "decimal":
                                                                                    const currentItem = (props.data as IErrorItem[])?.find((item: IErrorItem) => item.idGlobal === cell.idGlobal);
                                                                                    const isError = shouldHighlightCell(currentItem, cell.propertyName);
                                                                                    const isValidationError = props.isCellInvalid?.(cell, item) ?? false;
                                                                                    return (
                                                                                        <div className={styles.inputWrapper}>
                                                                                            <DecimalInputV2
                                                                                                disabled={props.documentStateProc ? true : (cell.propertyName === 'retailPriceIncVat' &&
                                                                                                    props.mapDisabledField?.get(cell.idGlobal)) ||
                                                                                                    false}
                                                                                                inputId={uuidv4()}
                                                                                                style={{
                                                                                                    width: '100%',
                                                                                                    height: pluginSettings.rowHeight ? (pluginSettings.rowHeight - 10) : ROW_HEIGHT
                                                                                                }}
                                                                                                value={Number(cell.value) || 0}
                                                                                                inputClassName={
                                                                                                    isError
                                                                                                        ? `${styles.errInput} ${styles.gridRowCellError}`
                                                                                                        : isValidationError
                                                                                                            ? styles.errInput
                                                                                                            : props.itemsValidation?.find((x) => x.idGlobal === cell.idGlobal)?.err
                                                                                                                ? styles.errInput
                                                                                                                : styles.defInput
                                                                                                }
                                                                                                onEnter={(value: number) => {
                                                                                                    props.onColumnEnter?.({
                                                                                                        propertyName: cell.propertyName,
                                                                                                        value: Number(value),
                                                                                                        idGlobal: cell.idGlobal,
                                                                                                    });
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    props.onClick?.(item);
                                                                                                    setSelectedItem(item);
                                                                                                    props.onSelect?.(item);

                                                                                                    setCurrentTdIndex(takeCurrentTdIndex);
                                                                                                    setCurrentTrIndex(rowIndex);
                                                                                                }}
                                                                                                onKeyDown={(event) => {
                                                                                                    if (event.key === 'Enter') {
                                                                                                        event.preventDefault();
                                                                                                        setSelectedRow(event);
                                                                                                    }
                                                                                                }}
                                                                                                onChange={(value: number) => {
                                                                                                    props.onChangeData?.({
                                                                                                        propertyName: cell.propertyName,
                                                                                                        value: Number(value),
                                                                                                        idGlobal: cell.idGlobal,
                                                                                                    });
                                                                                                    setLastEditedIdGlobal(cell.idGlobal);
                                                                                                    if (props.itemsFilter?.find((x) => x.idItem === cell.idGlobal) && props.itemsValidation) {
                                                                                                        let f = props.itemsFilter?.find((x) => x.idItem === cell.idGlobal) as IItemFilter;
                                                                                                        if (Number(value) > f.quantityMax) {
                                                                                                            props.setItemsValidation?.(
                                                                                                                addValueToArray(
                                                                                                                    props.itemsValidation,
                                                                                                                    props.itemsValidation?.findIndex((x) => x.idGlobal === cell.idGlobal),
                                                                                                                    {
                                                                                                                        err: true,
                                                                                                                        message: t('grids.maxExceeded', { max: f.quantityMax }),
                                                                                                                        idGlobal: cell.idGlobal,
                                                                                                                    }
                                                                                                                )
                                                                                                            );
                                                                                                        } else if (Number(value) === 0) {
                                                                                                            props.setItemsValidation?.(
                                                                                                                addValueToArray(
                                                                                                                    props.itemsValidation,
                                                                                                                    props.itemsValidation?.findIndex((x) => x.idGlobal === cell.idGlobal),
                                                                                                                    {
                                                                                                                        err: true,
                                                                                                                        message: baseT("cannotBeZero"),
                                                                                                                        idGlobal: cell.idGlobal,
                                                                                                                    }
                                                                                                                )
                                                                                                            );
                                                                                                        } else {
                                                                                                            props.setItemsValidation?.(
                                                                                                                addValueToArray(
                                                                                                                    props.itemsValidation,
                                                                                                                    props.itemsValidation?.findIndex((x) => x.idGlobal === cell.idGlobal),
                                                                                                                    { err: false, message: "", idGlobal: cell.idGlobal }
                                                                                                                )
                                                                                                            );
                                                                                                        }
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    );
                                                                                case "string":
                                                                                    return (
                                                                                        <div className={styles.inputWrapper}>
                                                                                            <TextInput
                                                                                                value={cell.value}
                                                                                                inputId={uuidv4()}
                                                                                                style={{
                                                                                                    width: '100%',
                                                                                                    height: pluginSettings.rowHeight ? (pluginSettings.rowHeight - 10) : ROW_HEIGHT
                                                                                                }}
                                                                                                inputClassName={
                                                                                                    props.itemsValidation?.find((x) => x.idGlobal === cell.idGlobal)?.err ? styles.errInput : styles.defInput
                                                                                                }
                                                                                                onChange={(e) => {
                                                                                                    props.onChangeData?.({
                                                                                                        propertyName: cell.propertyName,
                                                                                                        value: e,
                                                                                                        idGlobal: cell.idGlobal,
                                                                                                    });
                                                                                                    setLastEditedIdGlobal(cell.idGlobal);
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    );
                                                                                case "boolean":
                                                                                    return (
                                                                                        (props.hideBooleanIfNull && cell.value === null) ?
                                                                                            null
                                                                                            :
                                                                                            <CheckBox
                                                                                                defaultChecked={cell.value ?? false}
                                                                                                disabled={false}
                                                                                                id={`id${cell.value}${cell.propertyName}${uuidv4()}`}
                                                                                                onChanged={(checked) => {
                                                                                                    props.onChangeData?.({
                                                                                                        propertyName: cell.propertyName,
                                                                                                        value: checked as boolean,
                                                                                                        idGlobal: cell.idGlobal,
                                                                                                    });
                                                                                                    setLastEditedIdGlobal(cell.idGlobal);
                                                                                                }}
                                                                                            />
                                                                                    );
                                                                                case "number": {
                                                                                    const currentItem = (props.data as IErrorItem[])?.find((item: IErrorItem) => item.idGlobal === cell.idGlobal);
                                                                                    const isError = shouldHighlightCell(currentItem, cell.propertyName);
                                                                                    const isValidationError = props.isCellInvalid?.(cell, item) ?? false;

                                                                                    return (
                                                                                        <Tooltip
                                                                                            title={getToolTipTitle(cell)}
                                                                                            placement="top"
                                                                                            autoAdjustOverflow={false}
                                                                                            overlayStyle={{ maxWidth: 300 }}
                                                                                            getPopupContainer={() => document.body}
                                                                                        >
                                                                                            <div className={styles.inputWrapper}>
                                                                                                <NumberInputWithSideEffect
                                                                                                    max={maxValue(cell)}
                                                                                                    style={{
                                                                                                        width: '100%',
                                                                                                        height: pluginSettings.rowHeight ? (pluginSettings.rowHeight - 10) : ROW_HEIGHT,
                                                                                                    }}
                                                                                                    value={cell.value}
                                                                                                    min={getKizCount(props.items?.find((x) => x.idGlobal === cell.idGlobal))}
                                                                                                    propertyName={cell.propertyName}
                                                                                                    numerator={props.numerator}
                                                                                                    banEnterZerro={props.banEnterZerro}

                                                                                                    disabled={getIsNumberDisabled(cell)}
                                                                                                    inputClassName={
                                                                                                        isError
                                                                                                            ? `${styles.errInput} ${styles.gridRowCellError}`
                                                                                                            : isValidationError
                                                                                                                ? styles.errInput
                                                                                                                : props.itemsValidation?.find((x) => x.idGlobal === cell.idGlobal)?.err
                                                                                                                    ? styles.errInput
                                                                                                                    : styles.defInput
                                                                                                    }
                                                                                                    onEnter={(e) => {
                                                                                                        props.onColumnEnter?.({
                                                                                                            propertyName: cell.propertyName,
                                                                                                            value: e as string | number,
                                                                                                            idGlobal: cell.idGlobal,
                                                                                                        });
                                                                                                    }}
                                                                                                    onClick={() => {
                                                                                                        props.onClick?.(item);
                                                                                                        setSelectedItem(item);
                                                                                                        props.onSelect?.(item);

                                                                                                        setCurrentTdIndex(takeCurrentTdIndex);
                                                                                                        setCurrentTrIndex(rowIndex);
                                                                                                    }}
                                                                                                    onBlur={(e) => {
                                                                                                        props.onBlur?.({
                                                                                                            propertyName: cell.propertyName,
                                                                                                            value: e as string | number,
                                                                                                            oldValue: cell.value,
                                                                                                            idGlobal: cell.idGlobal,
                                                                                                        });
                                                                                                    }
                                                                                                    }
                                                                                                    onKeyDown={(event) => {
                                                                                                        if (event.key === 'Enter') {
                                                                                                            event.preventDefault();
                                                                                                            setSelectedRow(event);
                                                                                                        }
                                                                                                    }}
                                                                                                    onChange={(e) => {
                                                                                                        props.onChangeData?.({
                                                                                                            propertyName: cell.propertyName,
                                                                                                            value: e as string | number,
                                                                                                            idGlobal: cell.idGlobal,
                                                                                                        });
                                                                                                        setLastEditedIdGlobal(cell.idGlobal);
                                                                                                        if (props.itemsFilter?.find((x) => x.idItem === cell.idGlobal) && props.itemsValidation && !props.maxDiscountValue?.[cell.propertyName]) {
                                                                                                            let f = props.itemsFilter?.find((x) => x.idItem === cell.idGlobal) as IItemFilter;
                                                                                                            const validationIndex = props.itemsValidation?.findIndex((x) => x.idGlobal === cell.idGlobal);
                                                                                                            if (validationIndex !== undefined && validationIndex >= 0) {
                                                                                                                if (e > f.quantityMax) {
                                                                                                                    props.setItemsValidation?.(
                                                                                                                        addValueToArray(
                                                                                                                            props.itemsValidation,
                                                                                                                            validationIndex,
                                                                                                                            {
                                                                                                                                err: true,
                                                                                                                                message: t('grids.maxExceeded', { max: f.quantityMax }),
                                                                                                                                idGlobal: cell.idGlobal,
                                                                                                                            }
                                                                                                                        )
                                                                                                                    );
                                                                                                                } else if (e === 0) {
                                                                                                                    props.setItemsValidation?.(
                                                                                                                        addValueToArray(
                                                                                                                            props.itemsValidation,
                                                                                                                            validationIndex,
                                                                                                                            {
                                                                                                                                err: true,
                                                                                                                                message: baseT("cannotBeZero"),
                                                                                                                                idGlobal: cell.idGlobal,
                                                                                                                            }
                                                                                                                        )
                                                                                                                    );
                                                                                                                } else {
                                                                                                                    props.setItemsValidation?.(
                                                                                                                        addValueToArray(
                                                                                                                            props.itemsValidation,
                                                                                                                            validationIndex,
                                                                                                                            { err: false, message: "", idGlobal: cell.idGlobal }
                                                                                                                        )
                                                                                                                    );
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }}
                                                                                                    keyBan={true}
                                                                                                />
                                                                                            </div>
                                                                                        </Tooltip>
                                                                                    )
                                                                                };
                                                                                default:
                                                                                    return null;
                                                                            }
                                                                        })()
                                                                    ) : (
                                                                        <MainViewTd
                                                                            index={index}
                                                                            item={cell}
                                                                            row={item}
                                                                            getStyleCell={props.getStyleCell}
                                                                            orderedCells={orderedCells}
                                                                            columnWidth={cell.width}
                                                                            renderCustomCell={props.renderCustomCell}
                                                                        />

                                                                    )}
                                                                </td>
                                                            )
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })
                                }
                            </tbody>
                        </div>
                    </table>
                </div>
                <div className={styles.visibleHook} ref={visibleHook}></div>

                {props?.separator && <div onMouseDown={onMouseHoldDown} className={classNames(defaultStyles.separator, defaultStyles.separator_horizontal)}></div>}
                {props.hiddenPagination && (
                    <GridPaginator
                        nearPage={2}
                        pageNumber={props.filter.pageNumber}
                        totalCount={props.totalCount}
                        numberPerPage={props.filter.numberPerPage}
                        onPageNumberChange={props.onPageNumberChange}
                        onNumberPerPageChange={props.onNumberPerPageChange}
                        hiddenNumberPage={props.hiddenPagination?.["hiddenNumberPage"]}
                        hiddenCountRow={props.hiddenPagination?.["hiddenCountRow"]}
                    />
                )}
                {gridHeaderContextMenuVisible && (
                    <ContextMenu
                        id={getContextId("header", props.gridId)}
                        xPos={headerCtxPosX}
                        yPos={headerCtxPosY}
                        items={[
                            {
                                name: baseT("gridSettings"),
                                onClick: () => setShowGridHeaderSettings(true),
                            },
                        ]}
                    ></ContextMenu>
                )}
                {showGridHeaderSettings && (
                    <GridUISettings
                        plugin={pluginSettings}
                        defaultPlugin={defaultPlugin}
                        save={(e) => {
                            if (e.columns) {
                                setGridColumnsToSave({ columns: e.columns, save: true });
                            }
                            setPluginSettings({...pluginSettings, rowHeight: e.rowHeight})
                            setGridHeaderContextMenuVisible(false);
                            setShowGridHeaderSettings(false);
                        }}
                        cancel={() => {
                            setGridHeaderContextMenuVisible(false);
                            setShowGridHeaderSettings(false);
                        }}
                    ></GridUISettings>
                )}
            </div>
        </>
    );
};


interface IMainViewTdProps {
    item: IGridCellWithWidth;
    index: number;
    row: IChangeableGridRow;
    getStyleCell?: (processedCell: IGridCell, cells: IGridCell[]) => string | null;
    orderedCells: IGridCellWithWidth[];
    rowHeight?: number;
    columnWidth?: number;
    renderCustomCell?: (cell: IGridCellWithWidth, row: IChangeableGridRow) => React.ReactNode;
}

const MainViewTd: FC<IMainViewTdProps> = ({ item, index, row, getStyleCell, orderedCells, rowHeight, columnWidth, renderCustomCell }) => {
    const [isOverflow, setIsOverflow] = useState(false);
    const tdMainRef = useRef<HTMLDivElement>(null);
    const [formatTooltip, setFormatTooltip] = useState<string>('');

    const [copyVisibility, setCopyVisibility] = useState<boolean>(false);

    const CopyLowOpacity = 0.4;
    const CopyHighOpacity = 0.85;
    const [copyOpacity, setCopyOpacity] = useState<number>(CopyLowOpacity);

    const actualWidth = columnWidth || item.width;

    const syncWidth = useCallback(() => {
        if (!tdMainRef.current) return;
        
        const container = tdMainRef.current.closest('.gridWrapper__tables');
        if (!container) return;
        
        const table = container.querySelector('table');
        if (!table) return;
        
        const headerCell = table.querySelector(
            `thead tr td[data-property-name="${item.propertyName}"]`
        ) as HTMLElement;
        
        if (headerCell) {
            const computedWidth = window.getComputedStyle(headerCell).width;
            tdMainRef.current.style.width = computedWidth;
            tdMainRef.current.style.minWidth = computedWidth;

            const parentTd = tdMainRef.current.closest('td');
            if (parentTd) {
                parentTd.style.width = computedWidth;
                parentTd.style.minWidth = computedWidth;
            }
        }
    }, [item.propertyName]);

    useEffect(() => {
        const timeoutId = setTimeout(syncWidth, 0);
        
        const handleResize = () => {
            syncWidth();
        };
        
        document.addEventListener('resize-start', handleResize);
        document.addEventListener('resize-end', handleResize);
        
        return () => {
            clearTimeout(timeoutId);
            document.removeEventListener('resize-start', handleResize);
            document.removeEventListener('resize-end', handleResize);
        };
    }, [syncWidth]);

    useEffect(() => {
        if (!tdMainRef.current || !actualWidth) return;
        
        tdMainRef.current.style.width = `${actualWidth}px`;
        
        const parentTd = tdMainRef.current.closest('td');
        if (parentTd) {
            parentTd.style.width = `${actualWidth}px`;
        }
    }, [actualWidth]);

    const actionForRef = (ref) => {
        if (ref && ref.triggerRef && ref.triggerRef.current) {
            const span = ref.triggerRef.current;
            const spanWidth = span.scrollWidth;

            const tdElement = span.parentNode;
            const tdElementCss = getComputedStyle(tdElement);
            const tdWidth = tdElement.offsetWidth - (parseFloat(tdElementCss.paddingLeft) + parseFloat(tdElementCss.paddingRight))

            spanWidth > tdWidth ? setIsOverflow(true) : setIsOverflow(false);
        }
    };

    const customContent = renderCustomCell?.(item, row);
    if (customContent) {
        return (
            <div
                ref={tdMainRef}
                style={{
                    width: `${actualWidth}px`,
                    height: rowHeight,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: 50,
                    position: 'relative'
                }}
                data-order-number={item.order}
                data-property-name={item.propertyName}
                onMouseEnter={() => {
                    actionForRef(tdMainRef);
                    setCopyVisibility(true);
                    syncWidth();
                }}
                onMouseLeave={() => {
                    setCopyVisibility(false);
                }}
            >
                {customContent}
            </div>
        );
    }

    return (
        <div
            ref={tdMainRef}
            style={{
                width: `${actualWidth}px`,
                height: rowHeight,
                cursor: "default",
                display: "flex",
                minWidth: 50
            }}
            data-order-number={item.order}
            data-property-name={item.propertyName}
            onMouseEnter={() => {
                actionForRef(tdMainRef);
                setCopyVisibility(true);
                syncWidth();
            }}
            onMouseLeave={() => {
                setCopyVisibility(false);
            }}
        >
            <Tooltip
                placement="top"
                autoAdjustOverflow={false}
                overlayStyle={{ maxWidth: 300 }}
                getPopupContainer={() => document.body}
                ref={(ref) => actionForRef(ref)}
                className={styles.gridRowCellText} 
                title={isOverflow && formatTooltip}
            >
                <span style={{ width: '100%' }}>
                    <FormattedValueView newValue={item} setFormatTooltip={setFormatTooltip} />
                </span>
            </Tooltip>
            <span
                style={{
                    opacity: copyVisibility ? copyOpacity : 0,
                    transition: "opacity 0.3s ease-in",
                    marginRight: -10,
                    paddingLeft: 1,
                    width: 16,
                    height: 16,
                    cursor: "pointer",
                    backgroundColor: "white",
                    borderRadius: 3
                }}
                onClick={async () => {
                    await copyToClipboard(getFormattedCellValue(item));
                }}
            >
                <ActionIcons.CopyMiniIcon
                    onMouseEnter={() => setCopyOpacity(CopyHighOpacity)}
                    onMouseLeave={() => setCopyOpacity(CopyLowOpacity)}
                />
            </span>
        </div>
    );
};
